import isNil from 'lodash/isNil';

const PRIMARY_NAME = ['A', 'N', 'H', 'L', 'Q', '9', '8'];
const INFO_NAME = ['F', 'G', 'T', 'I', 'J', '1', '2', '3'];
const SUCCESS_NAME = ['K', 'D', 'Y', 'B', 'O', '4', '5'];
const WARNING_NAME = ['P', 'E', 'R', 'S', 'C', 'U', '6', '7'];
const ERROR_NAME = ['V', 'W', 'X', 'M', 'Z'];

function getFirstCharacters(firstName: string, lastName: string) {
  const firstNameInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastNameInitial = lastName ? lastName.charAt(0).toUpperCase() : '';

  return firstNameInitial + lastNameInitial;
}

function getAvatarColor(name: string) {
  if (PRIMARY_NAME.includes(name)) return 'primary';
  if (INFO_NAME.includes(name)) return 'info';
  if (SUCCESS_NAME.includes(name)) return 'success';
  if (WARNING_NAME.includes(name)) return 'warning';
  if (ERROR_NAME.includes(name)) return 'error';
  return 'default';
}

// Deprecated in Minimal v4
export default function createAvatar(firstName?: string | null, lastName?: string | null) {
  if (isNil(firstName) || isNil(lastName)) return null;
  const name = getFirstCharacters(firstName, lastName);
  return {
    name: name,
    color: getAvatarColor(name),
  } as const;
}
